import React, { Suspense } from "react";
import { LoadingSpinner } from "src/components/ui/loading-spinner";

const PagerDutyIntegration = React.lazy(() => import("./PagerDutyIntegration"));

interface PagerDutyIntegrationProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function PagerDutyIntegrationLazy(props: PagerDutyIntegrationProps) {
  return (
    <Suspense fallback={<div className="flex justify-center p-4"><LoadingSpinner /></div>}>
      <PagerDutyIntegration {...props} />
    </Suspense>
  );
}